
export default class AlreadyStartedError extends Error {
    constructor() {
        super();
        this.name = "AlreadyStartedError"; 
    }
} 